/**
 * WPGraphQL often returns relay global IDs in `id` (base64); Gravity Forms
 * `submitGfForm` expects numeric database IDs in `fieldValues[].id`.
 */
export function gravityFormsDatabaseId(node: {
  databaseId?: number | null | undefined;
  id?: number | string | null | undefined;
}): number {
  if (typeof node.databaseId === "number" && !Number.isNaN(node.databaseId)) {
    return node.databaseId;
  }
  const rawId = node.id;
  if (typeof rawId === "number" && !Number.isNaN(rawId)) {
    return rawId;
  }
  if (typeof rawId === "string" && rawId.length > 0) {
    const direct = Number(rawId);
    if (!Number.isNaN(direct) && String(direct) === rawId.trim()) {
      return direct;
    }
    try {
      const decoded = atob(rawId);
      const lastColon = decoded.lastIndexOf(":");
      if (lastColon !== -1) {
        const parsed = parseInt(decoded.slice(lastColon + 1), 10);
        if (!Number.isNaN(parsed)) {
          return parsed;
        }
      }
    } catch {
      // ignore invalid base64
    }
  }
  return NaN;
}
